function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6667 11.0002C22 12.4135 22.6667 14.1922 22.6667 16.3335C22.6667 20.9548 17.7334 22.0348 15.3334 28.3335C14.444 27.5668 14 26.4562 14 25.0002C14 20.3575 20.6667 17.9468 20.6667 11.0002ZM15.3334 5.66683C16.9334 7.3175 17.7334 9.09616 17.7334 11.0002C17.7334 17.6015 9.67335 18.5895 11.3334 28.3335C9.11069 26.7868 8.00002 24.5642 8.00002 21.6668C8.00002 17.2335 15.3334 13.6668 15.3334 5.66683ZM9.33335 0.333496C11.1107 2.55616 12 4.55616 12 6.3335C12 14.6668 0.666687 17.2962 6.66669 28.3335C3.17869 27.5602 0.666687 24.3335 0.666687 20.3335C0.666687 11.6668 9.33335 10.3335 9.33335 0.333496Z"
});

function SvgGasHeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasHeat);
export default __webpack_public_path__ + "static/media/gas-heat.6ed6f6ba.svg";
export { ForwardRef as ReactComponent };